import comp from "./CustomMediaCard";
export default comp;
